/* ==========================================================================
   KLIMEK — Warenkorb ohne Seitenneuladen, plus die Box am Rand
   Wird von der Kollektionsseite und der Produktseite gleichermassen genutzt.
   Vorher lag dieselbe Logik in einem einzelnen Abschnitt; mit der zweiten
   Seite waere sie doppelt gepflegt worden.

   Erwartet im Markup:
     [data-klimek-warenkorb]  die Wurzel (ein Abschnitt)
     [data-warenkorb]         Adresse zum Hineinlegen, z. B. /cart/add
     [data-box]               der Knopf am Rand
     [data-box-zahl]          die Zahl darin
     [data-box-text]          derselbe Stand fuer Vorleseprogramme
   ========================================================================== */
(function () {
  function warenkorb(wurzel) {
    if (!window.fetch || !window.FormData) return;

    function schubladeFinden() {
      var s = document.querySelector('cart-drawer');
      return s && typeof s.renderContents === 'function' ? s : null;
    }

    var box = wurzel.querySelector('[data-box]');
    var boxZahl = wurzel.querySelector('[data-box-zahl]');
    var boxText = wurzel.querySelector('[data-box-text]');

    /* Denselben Inhalt einsetzen, den das Theme einsetzen wuerde — nur ohne
       das Oeffnen am Ende. Der Ueberlagerung muss die Schliessfunktion neu
       mitgegeben werden, weil sie mit dem alten Inhalt verschwindet. */
    function schubladeFuellen(schublade, ergebnis) {
      var teile = ergebnis.sections || {};
      var ziel = document.getElementById('CartDrawer');
      if (ziel && teile['cart-drawer']) {
        var frisch = new DOMParser()
          .parseFromString(teile['cart-drawer'], 'text/html')
          .querySelector('#CartDrawer');
        if (frisch) ziel.innerHTML = frisch.innerHTML;
      }
      var blase = document.getElementById('cart-icon-bubble');
      if (blase && teile['cart-icon-bubble']) {
        var frischeBlase = new DOMParser()
          .parseFromString(teile['cart-icon-bubble'], 'text/html')
          .querySelector('.shopify-section');
        if (frischeBlase) blase.innerHTML = frischeBlase.innerHTML;
      }
      schublade.classList.remove('is-empty');
      var innen = schublade.querySelector('.drawer__inner');
      if (innen) innen.classList.remove('is-empty');
      var ueberlagerung = schublade.querySelector('#CartDrawer-Overlay');
      if (ueberlagerung) ueberlagerung.addEventListener('click', schublade.close.bind(schublade));
    }

    function boxSetzen(anzahl) {
      if (!box) return;
      if (boxZahl) boxZahl.textContent = anzahl;
      if (boxText) boxText.textContent = anzahl + ' im Warenkorb';
      if (anzahl > 0) {
        box.hidden = false;
        /* Erst im naechsten Bild einblenden, sonst springt die Box ohne
           Uebergang ins Bild. */
        window.requestAnimationFrame(function () {
          box.classList.add('is-da');
          box.classList.remove('is-neu');
          void box.offsetWidth;
          box.classList.add('is-neu');
        });
      } else {
        box.classList.remove('is-da', 'is-neu');
        box.hidden = true;
      }
    }

    /* Der Warenkorb kann zwischendurch woanders veraendert worden sein —
       die Zahl kommt deshalb vom Shop, nicht aus einer eigenen Rechnung. */
    function zaehlerHolen() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (a) { return a.json(); })
        .then(function (w) { boxSetzen(w.item_count || 0); })
        .catch(function () {});
    }

    /* Wird in der Schublade die Menge geaendert oder ein Teil entfernt,
       meldet das Theme das ueber seinen eigenen Verteiler. Ohne das Zuhoeren
       zeigte die Box weiter die alte Zahl. */
    if (typeof subscribe === 'function') {
      subscribe('cart-update', function (nachricht) {
        var daten = nachricht && nachricht.cartData;
        if (daten && typeof daten.item_count === 'number') { boxSetzen(daten.item_count); return; }
        zaehlerHolen();
      });
    }

    /* Zurueck aus dem Kassenbereich oder aus dem Verlauf: Die Seite kommt
       dann aus dem Zwischenspeicher, mit der Zahl von vorhin. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) zaehlerHolen(); });

    if (box) {
      box.addEventListener('click', function () {
        var schublade = schubladeFinden();
        if (schublade) { schublade.open(box); return; }
        window.location.href = '/cart';
      });
    }

    var adresse = (wurzel.getAttribute('data-warenkorb') || '/cart/add') + '.js';
    var formulare = wurzel.querySelectorAll('form[action*="/cart/add"]');

    /* Zwei Stellen mit einer Aufgabe, weil sie sich nicht vereinen lassen:
       Eine Meldung, die per visibility verborgen wird, liest auch kein
       Vorleseprogramm mehr vor. Angesagt wird deshalb immer — zu sehen ist
       nur der Fehlerfall. Beim Erfolg reicht die Box als Rueckmeldung. */
    var ansage = document.createElement('p');
    ansage.className = 'klimek-p__ansage klimek-versteckt';
    ansage.setAttribute('role', 'status');
    ansage.setAttribute('aria-live', 'polite');
    wurzel.appendChild(ansage);

    var melder = document.createElement('p');
    melder.className = 'klimek-p__melder';
    melder.setAttribute('aria-hidden', 'true');
    wurzel.appendChild(melder);
    var melderUhr = null;

    function melden(text, sichtbar) {
      ansage.textContent = text;
      window.clearTimeout(melderUhr);
      if (!sichtbar) { melder.classList.remove('is-da'); return; }
      melder.textContent = text;
      melder.classList.add('is-da');
      melderUhr = window.setTimeout(function () { melder.classList.remove('is-da'); }, 6000);
    }

    Array.prototype.forEach.call(formulare, function (form) {
      form.addEventListener('submit', function (ereignis) {
        var knopf = form.querySelector('button[type="submit"]');
        if (knopf && knopf.disabled) return;

        /* Kein Theme mit Warenkorbschublade: gewoehnlich absenden. */
        var schublade = schubladeFinden();
        if (!schublade) return;
        ereignis.preventDefault();

        var daten = new FormData(form);
        daten.append('sections', 'cart-drawer,cart-icon-bubble');
        daten.append('sections_url', window.location.pathname);

        var beschriftung = knopf ? knopf.textContent : '';
        if (knopf) { knopf.disabled = true; knopf.textContent = 'Moment …'; }

        fetch(adresse, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: daten
        })
          .then(function (antwort) { return antwort.json(); })
          .then(function (ergebnis) {
            if (ergebnis.status) {
              melden(ergebnis.description || ergebnis.message || 'Das hat nicht geklappt.', true);
              return;
            }
            melden((ergebnis.product_title || 'Artikel') + ' liegt im Warenkorb.', false);
            /* Bewusst NICHT schublade.renderContents(): Das oeffnet die
               Schublade sofort und reisst mitten aus der Seite. Der Inhalt
               wird still nachgezogen, sichtbar wird nur die Box am Rand. */
            schubladeFuellen(schublade, ergebnis);
            zaehlerHolen();
          })
          .catch(function () {
            /* Netz weg oder Antwort unlesbar: lieber der alte Weg mit
               Neuladen als ein Knopf, der nichts tut. */
            form.submit();
          })
          .then(function () {
            if (knopf) { knopf.disabled = false; knopf.textContent = beschriftung; }
          });
      });
    });
  }

  function start() {
    var wurzeln = document.querySelectorAll('[data-klimek-warenkorb]');
    for (var i = 0; i < wurzeln.length; i++) warenkorb(wurzeln[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
